import {
	missionHeroImage,
	missionHeroMobileImage,
	missionImage,
} from "../images";

export const heroData = [
	{
		heading: "Mentorship",
		imageSource: [missionHeroImage, missionHeroMobileImage],
	},
];

export const mentorshipData = [
	{
		imageSource: missionImage,
		// heading: "Our MISSION",
		// subHeading: "To promote and teach Holistic Education.",
		description: [
			"HeadHeartHand Foundation is a non-profit registered charity located in Surrey, British Columbia, Canada. Our unique mentorship program is tailored to provide Holistic Education to both mentors and mentees and open to all members of the public from age 19 (nineteen). This involves educating the Head, Heart and Hand to develop the intellectual, emotional, physical, moral and social well-being of community members.",
			"We are kick-starting this pilot mentorship program with a limited set of mentors and mentees to cover about 20 support areas. Confirmation emails will be sent to the mentors and mentees selected for the pilot phase.",
		],
		link: "https://bit.ly/3hmentorship",
		linkText: "Read More",
	},
];
